/**
 * Small Persian sentence helpers for tour copy that depends on the viewer
 * (which buttons they hold, which tabs they see).
 */

/** «الف»، «ب» و «ج» — the items joined as a Persian list (no quotes added). */
export function joinFa(items: readonly string[]): string {
  if (items.length === 0) return '';
  if (items.length === 1) return items[0] ?? '';
  return `${items.slice(0, -1).join('، ')} و ${items[items.length - 1] ?? ''}`;
}

/** A UI label as the copy quotes it: «ثبت جلسه». */
export function quoted(label: string): string {
  return `«${label}»`;
}
